<div mat-dialog-title>{{'stations.configuredGraphs.modal.modalRemoveGraph.title' | translate}}</div>
@if (!loading) {
  <div>
    @if (!deleteError && !deleteSuccess) {
      <mat-dialog-content>
        {{'stations.configuredGraphs.modal.modalRemoveGraph.content' | translate : {graphName: station.name + ' - ' + configuredGraph.name} }}
      </mat-dialog-content>
      <div mat-dialog-actions class="mat-actions">
        <button class="btn btn--danger" type="submit" (click)="removeConfiguredGraph()">{{'action.delete' | translate}}</button>
        <button mat-dialog-close
          class="btn btn--outline-grey-color ml-20">{{'action.cancel' | translate}}
        </button>
      </div>
    } @else {
      @if (deleteSuccess) {
        <div>
          <div class="alert alert-success">
            {{deleteSuccess}}
          </div>
          <mat-dialog-actions>
            <button class="btn btn--outline-grey-color" [mat-dialog-close]="true">{{'action.close' | translate}}</button>
          </mat-dialog-actions>
        </div>
      }
      @if (deleteError) {
        <div>
          <div class="alert alert-error">
            {{deleteError}}
          </div>
          <mat-dialog-actions>
            <button class="btn btn--outline-grey-color" mat-dialog-close>{{'action.close' | translate}}</button>
          </mat-dialog-actions>
        </div>
      }
    }
  </div>
}
